export const NAV_ITEMS = [
  { name: "home", href: "/", icon: "solar:home-2-linear" },
  { name: "projects", href: "/projects", icon: "solar:case-minimalistic-linear" },
  { name: "agents", href: "/agents", icon: "solar:ghost-smile-linear" },
  { name: "blog", href: "/blog", icon: "solar:notebook-linear" },
  { name: "stats", href: "/stats", icon: "solar:chart-2-linear" },
  { name: "about", href: "/about", icon: "solar:user-circle-linear" },
  { name: "contact", href: "/contact", icon: "solar:letter-linear" },
];

export const MOBILE_NAV_GROUPS = [
  {
    group: 'home',
    items: [
      { name: 'home', href: "/", icon: "solar:home-2-linear" },
      { name: 'projects', href: "/projects", icon: "solar:case-minimalistic-linear" },
      { name: 'agents', href: "/agents", icon: "solar:ghost-smile-linear" },
      { name: 'blog', href: "/blog", icon: "solar:notebook-linear" },
      { name: 'stats', href: "/stats", icon: "solar:chart-2-linear" },
    ],
  },
  {
    group: 'about',
    items: [
      { name: 'about', href: "/about", icon: "solar:user-circle-linear" },
      { name: 'contact', href: "/contact", icon: "solar:letter-linear" },
    ],
  },
];
